<template>
    <section class="section section-offer bg-primary-color-light">
        <div class="container">
            <div class="content">
                <h2>Unser Autostrom-Angebot</h2>
                <div class="columns">
                    <div class="column is-1">
                       <figure class="media-left">
                            <p class="image is-64x64">
                                <img src="./../assets/img/icons/icon_offer.png">
                            </p>
                        </figure>
                    </div>
                    <div class="column is-7">
                        <h3>Car Strom</h3>
                        <p><strong>Das smarte Angebot zum schlanken Preis.</strong></p>
                        <ul>
                            <li>incl. Wallbox-Installation</li>
                            <li>24 h Service-Hotline</li>
                            <li><a href="#">Zu den Tarifdetails</a></li>
                        </ul>
                        <button class="button is-link">Jetzt wechseln</button>
                    </div>
                    <div class="column">
                        <span class="preis second-color">100,83 €</span>
                        <strong>Unser Preis im Monat</strong>

                        <table>
                            <tr>
                                <td>Grundpreis</td>
                                <td>6,42 €/Monat</td>
                            </tr>
                            <tr>
                                <td>Arbeitspreis</td>
                                <td>25,54 ct/kWh</td>
                            </tr>
                        </table>
                        Ersparnis zu bundesweitem, durschschnittlichem Autostrom-Preis:
                        <span class="preis primary-color">19,91 € / Monat</span>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Offer"
    }
</script>

<style scoped>

</style>